interface Props {
  label: string;
  value: string | number;
  sub: string;
  colorClass: string;
}
export function MetricCard({
  label,
  value,
  sub,
  colorClass
}: Props) {
  return <div className="mc" data-id="element-407">
      <div className="ml" data-id="element-408">{label}</div>
      <div className={`mv ${colorClass}`} data-id="element-409">{value}</div>
      <div className="ms" data-id="element-410">{sub}</div>
    </div>;
}